import React, { forwardRef } from 'react';
import { Tabs, TabsProps } from '@mui/material';

export interface SegmentedControlsProps extends Omit<TabsProps, 'template'> {}

/**
 * Segmented Controls is a proxy component to <Tabs template="segmented" />
 */
export const SegmentedControls: React.FC<SegmentedControlsProps> = forwardRef((props, ref) => {
  return <Tabs {...props} ref={ref} template="segmented" />;
});
